<template lang="pug">
    ApolloQuery(:query="require('../graphql/ThankYou.gql')", :variables="variables")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.thank_you && data.job)")
            .thankyou(v-else)
                MetaTags(v-bind="data.job.meta_tags")
                LayoutBannerBreadCrumb(:locale='locale', :cover="data.thank_you.cover", :title="data.thank_you.title", :name="locale == 'en' ? 'Thank you' : '多謝你的申請'", :prefix="locale == 'en' ? 'Application Form' : '工作機會'", prefix_url="/jobs", :prefix_two="data.job.title", :prefix_two_url="/jobs/ + data.job.id")
                .container.container-thankyou
                    .row
                        .col-12
                            .msg
                                .msg__icon
                                    img(v-bind="data.thank_you.icon")
                                .msg__msg
                                    .msg__header
                                        | {{data.thank_you.header}}
                                    .msg__body(v-html="insertJob(data.job, data.thank_you.message)")
                    .row
                        .col-12
                            .action.action-center
                                router-link(to="/jobs", :title="data.thank_you.btn_home").action__button.action__button-back
                                        | {{data.thank_you.btn_home}}
</template>

<script>
    import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
    import Loading from "../components/Loading.vue";
    import FormDataStore from "../stores/FormDataStore";
    import PageNotFound from './PageNotFound';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "ThankYou",
        props: {
            locale: String,
            jobID: String,
        },
        components: {
            MetaTags,
            PageNotFound,
            LayoutBannerBreadCrumb,
            Loading
        },
        computed: {
            job_id() {
                const job_id = parseInt(this.jobID);
                return job_id ? job_id : -1
            },
            variables() {
                return {
                    locale: this.locale,
                    job_id: this.job_id
                };
            }
        },
        beforeCreate() {
            if (!FormDataStore.validated) {
                this.$router.push('apply');
            }
        },
        mounted() {
            FormDataStore.clear();
        },
        methods: {
            insertJob(job, html) {
                let jobHtml = null;
                if (this.job_id < 0) {
                    jobHtml = html.replace('JOB_TITLE_REPLACEMENT', '').replace(/\{.*\}/, '');
                } else {
                    jobHtml = html.replace('JOB_TITLE_REPLACEMENT', job.title).replace('{', '').replace('}', '');
                    const category = job.categories.length ? job.categories[0].name : null;
                    if (category)
                        jobHtml = jobHtml.replace('JOB_CATEGORY_REPLACEMENT', category);
                }
                return jobHtml;
            }
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"
    .container-thankyou
        padding: 4rem 0 13rem
        @include media-breakpoint-down(md)
            padding: 2rem 15px 4rem

    .image
        text-align: center

    .msg
        text-align: center

        &__icon,
        &__msg
            display: inline-block
            text-align: left
            vertical-align: top
            @include media-breakpoint-down(md)
                width: 100%

        &__icon
            @include media-breakpoint-down(md)
                margin-bottom: 1rem

            img
                @include media-breakpoint-down(md)
                    max-height: 10vh
                    width: auto

        &__msg
            padding-left: 2rem
            @include media-breakpoint-down(md)
                padding-left: 0

        &__header
            font-size: 3rem
            color: #03d3bf
            @include media-breakpoint-down(md)
                font-size: 1.5rem

        &__body
            font-size: 2rem
            @include media-breakpoint-down(md)
                font-size: 1.25rem

    .action
        margin-top: 3rem
        @include media-breakpoint-down(md)
            margin-top: 1rem
            padding-left: 15px
            padding-right: 15px

    .action__button
        padding: .5rem 1rem
        @include media-breakpoint-down(md)
            max-width: 50%
</style>

<style lang="sass">
    .msg__body
        p:last-child
            line-height: .7
        @media (max-width: 1024px)
            p:last-child
                line-height: 1.4
</style>
